export const INVITATION_TEEN_EVENTS = {
  VIEW_TEEN_INFORMATION_VIRTUAL_CARD_FORM:
    'view_teeninformation_virtualcardform',
  VIEW_TEEN_INFORMATION_VIRTUAL_CARD_FORM_ERROR:
    'view_teeninformation_virtualcardform_error',
  SELECT_TEEN_INFORMATION_NEXT_FORM: 'select_teeninformation_nextform',
  SELECT_BACK_TEEN_INFORMATION_CONFIRM_DATA:
    'select_back_teen_information_confirm_data',
  SELECT_TEEN_INFORMATION_SAVE_FORM: 'select_teeninformation_saveform',
  VIEW_TEEN_INFORMATION_SAVE_FORM_SUCCESS:
    'view_teeninformation_saveform_success',
  VIEW_TEEN_INFORMATION_SAVE_FORM_ERROR: 'view_teeninformation_saveform_error',
  VIEW_TEEN_INFORMATION_SAVE_FORM_WITH_TEEN_DATA:
    'view_teeninformation_saveform_with_teen_data',
} as const;
